import apiClient from './api/client'
import type { BuildInfo } from '../types/build.types'

/**
 * Fetch current build version information from backend API
 * 
 * @returns Promise with build information
 * @throws Error if request fails
 */
export async function getBuildInfo(): Promise<BuildInfo> {
  try {
    const response = await apiClient.get<BuildInfo>('/build');
    
    if (!response.data) {
      throw new Error('Invalid response format from API')
    }

    return response.data
  } catch (error) {
    console.error('Failed to fetch build info:', error)
    throw new Error('Unable to load build information')
  }
}
